import { useCallback, useRef, useState } from "react";

// Share the lock between saving and closing so an older save cannot race closure.
export function useEncounterSave() {
  const pending = useRef(false);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  const runSave = useCallback(async (operation) => {
    if (pending.current) return false;
    pending.current = true;
    setSaving(true);
    setSaveError("");
    try {
      await operation();
      return true;
    } catch (error) {
      // Do not expose raw transport errors or clinical payloads in logs/UI.
      if (error?.response?.status === 422) {
        const detail = error.response.data?.detail;
        const messages = typeof detail === "string" ? [detail] : Array.isArray(detail)
          ? detail.map(item => item?.msg).filter(message => typeof message === "string") : [];
        if (messages.length) { setSaveError(messages.join("; ")); return false; }
      }
      setSaveError("Changes could not be saved. Keep this page open and try saving again. If your session is locked, sign in first.");
      return false;
    } finally {
      pending.current = false;
      setSaving(false);
    }
  }, []);

  return { runSave, saving, saveError };
}
